module.exports = __webpack_public_path__ + "img/ew-icon_inspirator_group.222b3e5c.svg";